export const VALIDATION_UNSAVED_CONTROL_ERROR: string = 'The Validation configuration for this control must be saved';
export const VALIDATION_UNSAVED_LOOP_ERROR: string = 'The Validation configuration for this loop must be saved';


// WEBPACK FOOTER //
// ./source/ts/constants/validation.ts